import type { Profile } from "@/types/domain";

interface Props {
  person: Pick<Profile, "data">;
  size?: number;
  ring?: boolean;
}

export function Avatar({ person, size = 56, ring = false }: Props) {
  const bg = person.data.color;
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: bg,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "var(--font-display)",
        fontStyle: "italic",
        fontWeight: 500,
        fontSize: size * 0.42,
        letterSpacing: -0.5,
        boxShadow: ring
          ? `0 0 0 3px var(--bg), 0 0 0 5px ${bg}, var(--shadow-sm)`
          : "var(--shadow-sm)",
        flexShrink: 0,
      }}
    >
      {person.data.initials}
    </div>
  );
}
